import { useEffect, useState, useRef } from "react";

export function useCategoryObserver() {
  const observer = useRef<IntersectionObserver>();
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  useEffect(() => {
    const handleObsever = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        const headerElement = document.querySelector(
          `a[data-category-name="${entry.target.id}"]`
        ) as HTMLSpanElement;

        if (entry?.intersectionRatio > 0) {
          setActiveCategory(entry.target.id);

          if (headerElement) {
            const headerParent = headerElement.parentElement;

            if (headerParent) {
              const distanceToScroll = headerElement.offsetLeft - 16; // subtract padding
              headerParent.scrollTo({
                left: distanceToScroll > 0 ? distanceToScroll : 0,
                behavior: "smooth",
              });
            }
          }
        } else {
          if (activeCategory === entry.target.id) {
            setActiveCategory(null);
          }
        }
      });
    };

    /*    const rootElement =
      document.querySelector("[data-category-list]") ?? document.body;*/

    observer.current = new IntersectionObserver(handleObsever, {
      //root: rootElement,
      //threshold: [0.1],
      //rootMargin: "80px 0px -10px 0px",
      rootMargin: "80px 0px -60% 0px",
      /*
        Extend margin 80px up, to account for top nav

       Wait for element to be around 60% from bottom, ie: most of viewport.
       */
    });

    if (observer.current !== undefined) {
      const elements = document.querySelectorAll("div[data-category]");
      elements.forEach((elem) =>
        observer?.current ? observer.current.observe(elem) : null
      );
    }
    return () => observer.current?.disconnect();
  }, [activeCategory]);

  return { activeCategory, setActiveCategory };
}
